import { Player } from '@anm/components/VideoPlayer';
import flatten from 'lodash/fp/flatten';
import { FC } from 'react';
import { Settings } from 'react-slick';

import EventVideoModalMobileSlider from './Wrapper';
import { useSliderItems } from './hooks';

const sliderSettings: Settings = {
  arrows: false,
  infinite: true,
  variableWidth: false,
  adaptiveHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1
};

const TemplateVideoSlider: FC = () => {
  let currentPlayerRefs: Player[][] = [];

  const pauseAllPlayers = () =>
    flatten(currentPlayerRefs).forEach(ref => ref.pause?.());

  const [sliderItems, playerRefs] = useSliderItems();

  currentPlayerRefs = playerRefs;

  const sliderCallbacks = {
    onSwipe: pauseAllPlayers
  };

  return (
    <EventVideoModalMobileSlider
      settings={{ ...sliderSettings, ...sliderCallbacks }}
    >
      {sliderItems}
    </EventVideoModalMobileSlider>
  );
};

export default TemplateVideoSlider;
